import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const PageBannerTranslations = wrapTranslationsSchema({
	name: 'PageBannerTranslations',
	title: 'Page Banner Translations',
	sanityId: 'pageBanner',
	fields: {
		showNavigation: 'Show navigation',
		hideNavigation: 'Hide navigation',
	},
});
